<template>
	<component :is="items.Component" v-slot:[slotType]  v-model="ruleFormObj[items.prop]" v-bind="items.componentProps"  v-on="items.on" v-if="items.prop">
		<slot></slot>
	</component>
	<component :is="items.Component" v-slot:[slotType] v-bind="items.componentProps"  v-on="items.on" v-else>
		<slot></slot>
	</component>
</template>
<script>
	export default { 
		props: {
			items: {
				type: Object,
				default: () => {
					return {}
				}
			},
			ruleForm: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		computed: {
			slotType() {
				return this.items.slot || 'default'
			}
		},
		data() {
			return {
				ruleFormObj: {}
			}
		},
		created() {
			this.$watch(() => this.ruleFormObj[this.items.prop], (news) => {
				console.log(this.ruleFormObj[this.items.prop], '123444')
				this.ruleForm[this.items.prop] = news
				// this.$set(this.ruleForm, this.items.prop, news)
			}, {deep: true})
		},
		watch: {
			items: {
				deep: true,
				immediate: true,
				handler(news) {
					if(news.prop) {
						// this.ruleForm[news.prop] = news.defaultValue
						this.$set(this.ruleForm, news.prop, news.defaultValue)
						this.ruleFormObj = {...this.ruleForm}
					}
				}
			}
		}
	}
</script>
<style lang="less" scoped></style>
